import React from 'react'
import "./order-ticket.css"
import { Loading, trackPage, Status } from '../twd/twd'
import { ContextProvider, useOrderTicket, STEPS } from './use-order-ticket'
import { Entry } from './entry'
import { Preview } from './preview'
import { Confirm } from './confirm'

export default (args) => {
    trackPage('order-ticket')

    return <React.Fragment>
        <ContextProvider {...args}>
            <Content />
        </ContextProvider>
        </React.Fragment>
}

const Content = () => {
    const { step, ticketStatus, autoPreview } = useOrderTicket()

    return <React.Fragment>
        <Loading status={autoPreview ? Status.LOADING : ticketStatus}>
            {step===STEPS.ENTRY && <Entry />}
            {step===STEPS.PREVIEW && <Preview />}
            {step===STEPS.CONFIRM && <Confirm />}
        </Loading>
    </React.Fragment>
}